import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-join-revolution',
  templateUrl: './join-revolution.component.html',
  styleUrls: ['./join-revolution.component.css']
})
export class JoinRevolutionComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
  }

  onJoinNow(): void {
    const isLoggedIn = !!this.authService.userValue;
    this.router.navigate([isLoggedIn ? '/profile' : '/login']);
  }

}
